<onego-header
    [title]="title"
    [menu]="menu"
    (loggedOut)="onLoggedOut()"
    [languageSwitcherLanguages]="supportedLanguages"
    [language]="currentLanguage"
    (languageChange)="setLanguage($event)"
/>
<div class="view-container">
    <router-outlet></router-outlet>
</div>
<app-socket-overlay></app-socket-overlay>
<div id="overlay-container"></div>
<canvas id="debugCanvas" [width]="window.innerWidth" [height]="window.innerHeight"></canvas>
<app-app-state-monitor></app-app-state-monitor>
